import React from 'react'
import PropTypes from 'prop-types'

function Section({
  sectionClassName = '',
  rowClassName = '',
  children,
}) {
  return (
    <section className={`${sectionClassName}`}>
      <div className="container-fixed">
        <div className={`row ${rowClassName}`}>
          {children}
        </div>
      </div>
    </section>
  )
}

Section.propTypes = {
  sectionClassName: PropTypes.string,
  rowClassName: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
}

export default Section
